<template>
  <path
    d="M18.87 10.3702C18.12 5.61018 13.87 2.02018 9.04999 2.00018C8.55999 2.00018 8.07999 2.03018 7.60999 2.10018C7.10999 2.17018 7.00999 2.83018 7.46999 3.06018C10.75 4.69018 13 8.08018 13 12.0002C13 15.9202 10.75 19.3102 7.46999 20.9502C7.01999 21.1802 7.10999 21.8402 7.60999 21.9102C8.07999 21.9702 8.55999 22.0002 9.04999 22.0002C13.87 21.9802 18.12 18.3902 18.87 13.6302C18.96 13.0802 18.98 12.5402 18.98 12.0002C18.98 11.4602 18.96 10.9202 18.87 10.3702Z"
  />
</template>
